import React from 'react'
import styled, {css} from 'styled-components'
import {getColor} from 'startlibs/lib/lib'
import {Icon, Button} from 'startlibs/lib/components'
import lighten from 'polished/lib/color/lighten'
import {enhanceInput} from 'startlibs/lib/form'

export const CheckoutPage = styled.div`
  .warning-text {
    color: #9e2e32;
    display: block;
  }
  .checkbox-list {
    padding-bottom: .5rem;
  }
  @media (max-width: 675px) {
    .profile-header.checkout-header.mobile-margin {
      padding: 1rem 0;
      margin-top: 0;
      a {
        margin-top: 1rem;
      }
    }
  }
`

export const ContentSection = styled.div`
  margin-top: 2rem;
  .card {
    padding: 1.5rem;
  }
`

export const CreditCardWrapper = styled(ContentSection)`
  margin-top: 2rem;
  .update-card-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .heading-text {
      flex-grow: 1;
      padding-right: 1rem;
    }
    .action-wrapper {
      flex-shrink: 0;
      padding-top: 2rem;
    }
  }
  @media (max-width: 350px) {
    .update-card-heading {
      flex-wrap: wrap;
      .heading-text, .action-wrapper {
        flex-basis: 100%;
        padding: 0;
      }
      ${Button} {
        width: 100%;
        margin-bottom: 1rem;
      }
    }
  }
`

export const SubscriptionPlanList = styled.div`
  margin: -0.5rem;
  display: flex;
  @media (max-width: 620px) {
    display: block;
    margin: 0.5rem -0.5rem;
  }
  h3 + & {
    margin-top: 1rem;
  }
`

export const PlanHeader = styled.div`
  background: ${getColor('main')};
  padding: 1.25rem;
  color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin: -1.5rem -1.5rem 1.25rem;
`

export const CurrentPlanLabel = styled.div`
  padding: 2px 4px 3px;
  font-size: 10px;
  line-height: 1;
  border-radius: 4px;
  background: rgba(0,0,0,0.1);
  align-self: flex-end;
  margin-left: auto;
  margin-right: -8px;
  margin-bottom: -5px;
`

export const SubscriptionPlan = styled.div`
  position: relative;
  background: white;
  border: 1px solid ${props => props.selected ? (props.discontinuedPlan ? getColor('gray120') : getColor('main')) : getColor('gray210')};
  border-radius: 5px;
  overflow: hidden;
  margin: 0.5rem;
  flex-basis: 0;
  flex-grow: 1;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  ${props => props.selected && css`
    &:after {
      content: '';
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      border-radius: 4px;
      border: 1px solid ${props => props.discontinuedPlan ? getColor('gray120') : getColor('main')};
      pointer-events: none;
    }
  `}
  ${props => props.discontinuedPlan && css`
    padding: 1rem;
    margin: -0.5rem 0 1.25rem;
    flex-direction: row;
    flex-wrap: wrap;
    ${PlanHeader} {
      padding: 0.75rem 1rem;
      margin: -1rem -1rem 0.75rem;
      text-align: left;
      font-size: 14px;
      flex-basis: 100%;
      flex-grow: 1;
      background: ${getColor('gray120')};
    }
    ul, li {
      margin-bottom: 0;
      font-size: 12px;
    }
  `}
`

export const PlanBillingOptionContainer = styled.div`
  @media (min-width:380px) and (max-width:620px) {
    display: flex;
    justify-content: space-between;
  }
`


export const InfoBox = styled.div`
  padding: 1rem;
  background: ${props => (lighten(0.5, getColor('main')(props)))};
  border: 1px solid ${props => (lighten(0.35, getColor('main')(props)))};
  color: ${getColor('main')};
  ${props => props.gray && css`
    background: ${getColor('gray150')};
    border: 0px;
    color: white;
  `
  }
  border-radius: 4px;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
`

export const OrderSummaryWrapper = styled(ContentSection)`
  .order {
    display: flex;
    > * {
      flex-basis: 50%;
    }
    .order-table {
      font-size: 13px;
      > div {
        display: flex;
        justify-content: space-between;
        ~ div {
          margin-top: 0.5rem;
        }
      }
    }
    .amount {
      white-space: nowrap;
      margin-left: 1rem;
    }
    .discount {
      color: ${getColor('success')};
    }
    .total {
      border-top: 1px solid rgba(0,0,0,0.25);
      padding-top: 0.5rem;
      margin-top: 0.5rem;
    }
  }
`
export const PromoCodeContainer = styled.div`
    padding-left: 1.5rem;
    margin-left: 1.5rem;
    border-left: 1px solid rgba(0,0,0,0.15);
`
export const TextInputWithButton = styled.div`
  display: flex;
  margin-bottom: -1rem;
  .input-container {
    flex-grow: 1;
  }
  ${Button} {
    margin-bottom: 1rem;
    margin-left: 0.5rem;
  }
`
export const CouponFeedback = styled.div`
  margin-top: -1.5rem;
  color: ${props => props.success ? getColor('success') : (props.error ? getColor('alert') : getColor('gray120'))};
  .applied-coupon {
    padding: 1px 0.5rem;
    font-size: 11px;
    border-radius: 5px;
    color: white;
    font-weight: 600;
    display: inline-block;
    margin-right: 0.25rem;
    margin-bottom: 0.25rem;
    background-color: ${props => props.success ? getColor('success') : (props.error ? getColor('alert') : '')};
  }
`
export const StripeInput = styled.div`
  width: 100%;
  border: 1px solid ${getColor('gray210')};
  border-radius: 5px;
  background: white;
  position: relative;
  height: 3rem;
  padding: 0.7rem;
  &.StripeElement--focus {
    border-color: ${getColor('gray180')};
    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);
  }
  &.StripeElement--invalid {
    border-color: ${getColor('alert')} !important;
  }
`

export const CreditCardIcon = styled.img`
  width: 29px;
  position: absolute;
  bottom: 0.75rem;
  right: 0.75rem;
`

export const PlanPrice = styled.div`
  line-height: 1;
  font-weight: 600;
  font-size: 13px;
  padding-right: 1.25rem;
  color: ${getColor('gray90')};
  flex-basis: 100%;
`

export const PlanPriceDetail = styled.div`
  color: ${getColor('success')};
  font-size: 11px;
  font-weight: 600;
  padding-right: 0.25rem;
`

const PlanBillingOption = styled.label`
  padding: 0.5rem 0.75rem;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,0.15);
  margin-top: 0.5rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
  align-self: flex-start;
  ${props => props.selected ? css`
    color: white;
    background-color: ${props.discontinuedPlan ? getColor('gray120') : getColor('main')};
    ${PlanPrice}, ${PlanPriceDetail} {
      color: white !important;
    }
  ` : `
    &:hover {
      background: rgba(0,0,0,0.05);
    }
  `};
  input {
    opacity: 0;
    position: absolute;
    left: -20000000px;
  }
  ${Icon} {
    position: absolute;
    right: 8px;
    top: 5px;
    font-size: 16px;
    color: white;
  }
  ${props => !props.discontinuedPlan && `
    @media (min-width:380px) and (max-width:620px) {
      flex-basis: 49%;
    }
  `}
`

export const ServicesOfferingWrapper = styled.div `
  margin-top: 2rem;
  .card {
    padding: 1.5rem 1.5rem 1.5rem 7.5rem;
    position: relative;
    background-color: #dcf3ff;
    border-color: #b6d3e2;
  }
  img {
    width: 100px;
    position: absolute;
    left: -1.75rem;
    top: 1.5rem;
  }
`

export const PlanRadio = enhanceInput(({value, disabled, className, name, hasErrors, toggle, children, tabIndex, stringifyValue, fieldValue, setFromField, discontinuedPlan}) => {
  const checked = stringifyValue ? stringifyValue(value) === stringifyValue(fieldValue) : value === fieldValue
  return <PlanBillingOption onClick={(e) => e.stopPropagation()} disabled={disabled} selected={checked}
                            discontinuedPlan={discontinuedPlan}>
    <input disabled={disabled} type="radio" value={stringifyValue ? stringifyValue(fieldValue) : fieldValue} name={name}
           tabIndex={tabIndex}
           onChange={setFromField}
           checked={checked}
    />
    {children}
    {checked && <Icon icon="check"/>}
  </PlanBillingOption>
})



// WEBPACK FOOTER //
// ./src/javascripts/checkout/CheckoutComponents.jsx